import { ThemeConfig } from 'antd'
import _ from 'lodash'
import themeJSON from './theme.json'

export const theme: any = _.merge({}, themeJSON, {
  components: {
    Menu: {
      collapsedWidth: 52,
    },
  },
})
